<template>
    <path
        d="m 416.97257,334.13114 -14.69,-0.02 -0.52,-3.26 0.92,-1.83 0.38,-3.73 11.95,0.01 1.83,1.98 0.06,2.21 -0.59,1.19 -0.21,2.44 z"
        title="Distrito Federal"
        id="BR-DF"
    />
</template>